import React from "react";

// icons
import ChevronRight from "../../assets/images/icons/rebrand/chevron-right.svg";

interface RecipientTypeCardProps {
  icon: string;
  label: string;
  onSelect: () => void;
}

const RecipientTypeCard = ({ icon, label, onSelect }: RecipientTypeCardProps) => (
  <button type="button" className="bwp-recipient-card" onClick={onSelect}>
    <div className="bwp-recipient-card__avatar">
      <img src={icon} alt="" />
    </div>

    <div className="bwp-recipient-card__lines">
      <p className="bwp-recipient-card__name">{label}</p>
    </div>

    <img src={ChevronRight} alt="" className="bwp-recipient-card__chevron" />
  </button>
);

export default RecipientTypeCard;